module.exports = __webpack_public_path__ + "img/at.33d39054.svg";